import {takeLatest} from 'redux-saga/effects';

import {assignPubSaga} from './assignPub/saga';
import {deleteEditorSaga} from './delete/saga';
import {getSingleEditor} from './get/saga';
import {getSingleEditorACS, updateEditorACS, unassignPubACS, assignPubACS, deleteEditorACS} from './requestAC';
import {unassignPubSaga} from './unassignPub/saga';
import {updateEditor} from './update/saga';

export function* singlePageEditorSaga() {
  yield takeLatest(getSingleEditorACS.type, getSingleEditor);
  yield takeLatest(updateEditorACS.type, updateEditor);
  yield takeLatest(unassignPubACS.type, unassignPubSaga);
  yield takeLatest(assignPubACS.type, assignPubSaga);
  yield takeLatest(deleteEditorACS.type, deleteEditorSaga);
}
